import * as Yup from 'yup';

Yup.setLocale({
    mixed: {
        required: 'Required field',
    },
});